import { Button, Form, Input, message, Modal } from 'antd';
import React, { useState } from 'react';

import type { OutsourcedVendor } from '@/types/database/outsourcedVendor';

import {
  createOutsourcedVendor,
  updateOutsourcedVendor,
} from '../../helpers/api';
import { getInitialValues } from '../../helpers/ui';

const { useForm, Item } = Form;

type FormDataType = {
  name: string;
  phone: string;
  contactPerson: string;
};

const EditVendor: React.FC<{
  buttonLabel: string;
  editVendor?: OutsourcedVendor;
  updateVendors: () => void;
}> = ({ buttonLabel, editVendor, updateVendors }) => {
  const [open, setOpen] = useState(false);

  const [form] = useForm<FormDataType>();

  const defaultValues = getInitialValues(editVendor);

  const handleFinish = async (data: FormDataType) => {
    const type = editVendor ? 'update' : 'create';
    enum TypeMessages {
      update = '修改',
      create = '新增',
    }
    try {
      if (!editVendor) {
        await createOutsourcedVendor(data);
      } else {
        await updateOutsourcedVendor({
          ...editVendor,
          ...data,
        });
      }
      message.success(`${TypeMessages[type]}成功`);
      updateVendors();
      setOpen(false);
      form.resetFields();
    } catch (error) {
      console.error(error);
      message.error(`${TypeMessages[type]}失敗`);
    }
  };

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
        }}
      >
        {buttonLabel}
      </Button>
      <Modal
        open={open}
        title="廠商資訊"
        cancelButtonProps={{ type: 'primary' }}
        cancelText="取消"
        onCancel={() => {
          setOpen(false);
          form.resetFields();
        }}
        okButtonProps={{ type: 'text' }}
        okText="確認"
        onOk={form.submit}
        destroyOnClose
      >
        <Form
          form={form}
          initialValues={defaultValues}
          onFinish={handleFinish}
          labelCol={{ span: 24 }}
        >
          <Item
            name="name"
            label="廠商名稱"
            rules={[{ required: true, message: '請輸入廠商名稱' }]}
          >
            <Input />
          </Item>
          <Item name="phone" label="廠商電話">
            <Input />
          </Item>
          <Item name="contactPerson" label="聯繫窗口名稱">
            <Input />
          </Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditVendor;
